import { AiOutlineAlert } from "react-icons/ai"
import './DefaultNotification.css';

export const DefaultNotification = ({ data, closeToast, toastProps }) => {
	return (
		<div className="default-toast">
			{data.isAlert && (
				<div className="toast-icon">
					<AiOutlineAlert size={26} />
				</div>
			)}
			<div className="toast-content">
				<h3>{data.title}</h3>
				<p>{data.message}</p>
			</div>
		</div>
	)
}